export default __webpack_public_path__ + "static/videoN1-fbd5b5886cccd9a2be979ec2d5ae31b9.jpg";